module.exports = __webpack_public_path__ + "static/media/landing-banner.4f9d86c9.svg";